/** Migrate summaryLanguage "detect" to default english */
export function migrateDetectLanguage(response: any): any {
  if (response['agent_copilot']?.summaryLanguage === 'detect') {
    response['agent_copilot'].summaryLanguage = 'en';
  }
  return response;
}
